// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentMedicationModel } from './enrollmentMedicationModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentAccumulatorModel {
    'medications'?: Array<EnrollmentMedicationModel>;
    'medicationMaxBenefit'?: number;
    'remaingMedicationBenefit'?: number;
    'totalMedicationPaid'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentAccumulatorModel>> = [
        {
            "name":     "medications",
            "baseName": "medications",
            "type":     "Array<EnrollmentMedicationModel>"
        },
        {
            "name":     "medicationMaxBenefit",
            "baseName": "medicationMaxBenefit",
            "type":     "number"
        },
        {
            "name":     "remaingMedicationBenefit",
            "baseName": "remaingMedicationBenefit",
            "type":     "number"
        },
        {
            "name":     "totalMedicationPaid",
            "baseName": "totalMedicationPaid",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentAccumulatorModel.attributeTypeMap;
    }
}
